export const logErrorMessage = (message, error) => {
  const data = (error && error.response !== undefined) ? error.response : error;

  if (window.Rollbar) {
    window.Rollbar.error(message, data);
  }

  console.error(message, data);
};

export const showApplicationError = () => {
  alert(
    'Something unexpected happened, we are working on the fix. Please reload this page and try again.'
  );
};
